import React, { useState } from "react";
import {
  TouchableOpacity,
  View,
  Platform,
  StyleSheet,
  TextInput,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Keyboard,
} from "react-native";
import firebase from "firebase";
import DefaultText from "../../../components/text/DefaultText";
import * as authActions from "../../../store/actions/auth";
import { useDispatch } from "react-redux";

const ProfileUpdatePWScreen = (props) => {
  const [inputPassword, setinputPassword] = useState("");
  const dispatch = useDispatch();
  const user = firebase.auth().currentUser;

  const inputPasswordHandler = (enteredEmail) => {
    setinputPassword(enteredEmail);
  };
  const dismissKeyboard = () => {
    if (Platform.OS != "web") {
      Keyboard.dismiss();
    }
  };
  return (
    <KeyboardAvoidingView
      behavior="padding"
      keyboardVerticalOffset={50}
      style={styles.screen}
    >
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
        <View style={styles.keyboardContainer}>
          <View style={styles.emptyBox}></View>

          <View style={styles.headerContainer}>
            <DefaultText>Set New Password</DefaultText>
          </View>
          <TextInput
            placeholderTextColor="white"
            onChangeText={inputPasswordHandler}
            value={inputPassword}
            style={styles.inputContainer}
            secureTextEntry={true}
          />
          <TouchableOpacity
            style={styles.buttonContainer}
            onPress={() => {
              dispatch(authActions.setPassword(inputPassword)).then(() => {
                props.navigation.goBack({
                  inputPassword: inputPassword,
                });
              });
            }}
          >
            <DefaultText>Update</DefaultText>
          </TouchableOpacity>
        </View>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
    // <View style={styles.screen}>
    //   <Text style={styles.Prompt}> Enter your email to reset password </Text>
    //   <Text style={styles.EmailText}> Email </Text>
    //   <TextInput
    //     placeholder={" "}
    //     placeholderTextColor="white"
    //     onChangeText={ForgotPasswordEmailHandler}
    //     value={getForgotPasswordEmail}
    //     style={styles.EmailContainer}
    //   />
    //   <View style={{ marginTop: "10%", width: "80%" }}>
    //     <TouchableOpacity
    //       style={styles.SendEmailContainer}
    //       onPress={() => {
    //         props.navigation.navigate("EmailSentScreen");
    //       }}
    //     >
    //       <Text
    //         style={{
    //           color: "white",
    //           fontFamily: "JosefinSans_400Regular",
    //           fontSize: "16",
    //         }}
    //       >
    //         Send Email
    //       </Text>
    //     </TouchableOpacity>
    //   </View>
    // </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  keyboardContainer: {
    height: "100%",
    alignItems: "center",
  },

  emptyBox: {
    height: "5%",
  },
  headerContainer: {
    width: "80%",
    marginBottom: 6,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  subHeaderContainer: {
    width: "80%",
    margin: 16,
    flexDirection: "row",
    justifyContent: "center",
  },
  inputContainer: {
    color: "white",
    height: 40,
    width: "80%",
    borderBottomWidth: 1,
    fontFamily: "JosefinSans_400Regular",
    borderColor: "white",
    marginBottom: 55,
  },
  buttonContainer: {
    marginTop: 28,
    paddingVertical: 16,
    width: "80%",
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    borderColor: "white",
    marginBottom: 10,
  },
});

export default ProfileUpdatePWScreen;
